// extracted by mini-css-extract-plugin
module.exports = {"text":"orders_text__OpiAS","tooltip":"orders_tooltip__3gmA4"};